import { Link } from "react-router-dom";
import "./InstitutionServicesBanner.css";

const InstitutionServicesBanner = () => {
  return (
    <section className="institution-services-banner">
      <div className="institution-services-wrap">
        <div className="institution-services-copy">
          <h3>Need a Better Website and More Admissions?</h3>
          <p>
            We design and manage websites for schools, junior colleges, degree colleges, coaching institutes, and education brands across Andhra Pradesh.
          </p>
          <p>
            We also handle SEO, Google Business, local ranking, landing pages, Meta and Google ads, and complete digital marketing support to help institutions improve visibility, trust, and student enquiries.
          </p>
        </div>
        <div className="institution-services-actions">
          <Link to="/contact-us" className="institution-services-btn primary">Contact Us</Link>
          <a
            href="https://wa.me/916302388294?text=Hi%20Andhra%20Pradesh%20Education%20Hub%2C%20I%20want%20website%20and%20digital%20marketing%20support%20for%20my%20institution."
            target="_blank"
            rel="noopener noreferrer"
            className="institution-services-btn"
          >
            WhatsApp Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstitutionServicesBanner;
